<!-- /* [NT-APPLY-NAP-P-POP]NAP 자문신청(개인) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="NAP 자문 신청하기"
      disabledFooter
    >
      <div class="popupViewProfile">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img src="/images/manager/matching/demo1.png" alt="미국 국기" />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3 class="popupViewProfileCardImageTitle" style="color: #502423;">
              이 순 신
              <span class="personal-chip-green">학생</span>
            </h3>
            <h5 class="popupViewProfileCardImageDesc">032-222-3333</h5>
            <h5 class="popupViewProfileCardImageEmail">asdfsadf@naver.com</h5>
          </div>
        </div>

        <MatchingProcessItems />
        <section>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <h3 class="matchingHeadLine">신청서 작성</h3>
              <div style="margin-bottom: 50px;">
                <ValidationProvider
                  name="신청 대상 회원"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="신청 대상 회원"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="매칭신청 사유"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">연락처 정보</h3>
                <ValidationProvider
                  name="신청자 이름"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="신청자 이름"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="이메일 주소"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="이메일 주소"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="전화번호"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="전화번호"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">NAP 자문 요청</h3>
                <ValidationProvider
                  name="NAP 자문 요청 사항"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="NAP 자문 요청 사항"
                    v-model="form.test"
                    :errors="errors"
                  />
                </ValidationProvider>
              </div>

              <div class="modal-action">
                <router-link to="/corp/myMatchingStatusSent"
                  ><MainButton btnText="신청서 작성" color="green"
                /></router-link>
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import MatchingProcessItems from "../MatchingProcessItems.vue";
import InputField from "@/components/formControl/InputField.vue";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";

export default {
  name: "PopupNAPConsultationApplication",
  components: {
    BasicModal,
    MainButton,
    MatchingProcessItems,
    ValidationObserver,
    ValidationProvider,
    InputField,
    TextAreaInputField,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    onClickSubmitForm() {},
  },
};
</script>

<style lang="scss" scoped>
.itemRow {
  display: flex;
  align-items: flex-end;
  border: 1px solid #ababab;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  .itemRowText {
    padding-left: 16px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
  }
}
</style>
